import { Component, OnInit } from "@angular/core";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";

@Component({
  selector: "app-child-entity-detail-display",
  templateUrl: "./child-entity-detail-display.component.html",
  styleUrls: ["./child-entity-display.component.scss"]
})
export class ChildEntityDetailDisplayComponent
  extends ChildEntityDisplayComponent
  implements OnInit
{
  ngOnInit() {
    console.log("detail display");
    this._resource
      .getRelation(this._relation, { params: { projection: "detail" } })
      .subscribe((value) => (this.displayValue = value[this._displayField]));
  }
}
